import { Toast } from 'antd-mobile';
import {
  speedPassionMainInfo,
  speedPassionGiftSponsorInfo,
  speedPassionGetTaskInfo,
  speedPassionGetDialog,
  speedPassionGetTeamInfo,
  speedPassionJoinTeam,
  speedPassionChangeTeam,
  speedPassionGiftRank,
  speedPassionRankList,
} from '@/services/activity';

export default {
  namespace: 'speedPassion',
  state: {
    activityId: 1,
    status: 0,
    countDown: 0,
    title: '',
    titleUrl: '',
    rules: '',
    extraLimitedGiftRate: 0,
    canToUserInfo: false,
    limitedGiftInfoList: [],
    carRewardList: [],
    dailyRewards: [],
    totalRewards: [],
    giftSponsorList: [],
    taskInfoList: [],
    canChange: false,
    changeCoins: 0,
    teamInfoList: [],
    carRewardInfo: {},
    rewardInfoList: [],
    rewardDialogList: [],
    giftInfoList: [],
    currentGiftInfo: {},
    giftInfoRankList: [],
    giftRankLastId: '',
    rankList: [],
    selfInfo: {},
    lastId: '',
    carList: [],
    currentCar: {},
    dayList: [],
    currentDay: {},
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        activityId: payload.activityId || 1,
        status: payload.status || 0,
        countDown: payload.countDown || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        extraLimitedGiftRate: payload.extraLimitedGiftRate || 0,
        canToUserInfo: payload.canToUserInfo || false,
        limitedGiftInfoList: payload.limitedGiftInfoList || [],
        carRewardList: payload.carRewardList || [],
        dailyRewards: payload.dailyRewards || [],
        totalRewards: payload.totalRewards || [],
      };
    },
    updateGiftSponsorInfo(state, { payload }) {
      return {
        ...state,
        giftSponsorList: payload.giftSponsorList || [],
      };
    },
    updateTaskInfo(state, { payload }) {
      return {
        ...state,
        taskInfoList: payload || [],
      };
    },
    updateTeamInfo(state, { payload }) {
      return {
        ...state,
        canChange: payload.canChange || false,
        changeCoins: payload.changeCoins || 0,
        teamInfoList: payload.teamInfoList || [],
        carRewardInfo: payload.carRewardInfo || {},
      };
    },
    updateDialog(state, { payload }) {
      return {
        ...state,
        rewardInfoList: payload.rewardInfoList || [],
        rewardDialogList: payload.rewardDialogList || [],
      };
    },
    updateGiftRank(state, { payload }) {
      const { giftInfoList, currentGiftInfo, rankInfo, force } = payload;
      const { ranks } = rankInfo || {};
      let list = force ? [] : [...state.giftInfoRankList];
      let lastId = '';
      if (ranks && ranks.length) {
        list = [...list, ...ranks];
        lastId = ranks[ranks.length - 1].userId;
      }
      return {
        ...state,
        giftInfoList: giftInfoList || [],
        currentGiftInfo: currentGiftInfo || {},
        giftInfoRankList: list,
        giftRankLastId: lastId,
      };
    },
    updateRankList(state, { payload }) {
      const { carList, currentCar, dayList, currentDay, rankInfo, force } = payload;
      const { ranks, selfInfo = {} } = rankInfo || {};
      let list = force ? [] : [...state.rankList];
      let lastId = '';
      if (ranks && ranks.length) {
        list = [...list, ...ranks];
        lastId = ranks[ranks.length - 1].userId;
      }
      return {
        ...state,
        rankList: list,
        selfInfo: selfInfo,
        lastId: lastId,
        carList: carList || [],
        currentCar: currentCar || {},
        dayList: dayList || [],
        currentDay: currentDay || {},
      };
    },
    updateClearRank(state, { payload }) {
      return {
        ...state,
        giftInfoRankList: [],
        giftRankLastId: '',
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(speedPassionMainInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return data;
    },
    *getGiftSponsorInfo({ payload }, { call, put }) {
      const { error, data } = yield call(speedPassionGiftSponsorInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateGiftSponsorInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateGiftSponsorInfo',
        payload: data,
      });
      return data;
    },
    *getTaskInfo({ payload }, { call, put }) {
      const { error, data } = yield call(speedPassionGetTaskInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateTaskInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTaskInfo',
        payload: data,
      });
      return data;
    },
    *getTeamInfo({ payload }, { call, put }) {
      const { error, data } = yield call(speedPassionGetTeamInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateTeamInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTeamInfo',
        payload: data,
      });
      return data;
    },
    *changeTeam({ payload }, { call, put }) {
      const { error, data } = yield call(speedPassionChangeTeam, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *joinTeam({ payload }, { call, put }) {
      const { error, data } = yield call(speedPassionJoinTeam, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *getDialog({ payload }, { call, put }) {
      const { error, data } = yield call(speedPassionGetDialog, payload);
      if (error || !data) {
        yield put({
          type: 'updateDialog',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDialog',
        payload: data,
      });
      return data;
    },
    *getGiftRank({ payload }, { call, put, select }) {
      const { giftRankLastId } = yield select(state => state.speedPassion);
      const { data, error } = yield call(speedPassionGiftRank, { ...payload, lastId: payload.force ? '' : giftRankLastId, force: undefined });
      if (error) {
        yield put({
          type: 'updateGiftRank',
          payload: [],
        });
        return error;
      }
      yield put({
        type: 'updateGiftRank',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *getRankList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.speedPassion);
      const { data, error } = yield call(speedPassionRankList, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error) {
        yield put({
          type: 'updateRankList',
          payload: [],
        });
        return error;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, force: payload.force },
      });
      return data;
    },
    *clearRankList({ payload }, { put }) {
      yield put({
        type: 'updateClearRank',
        payload: { force: payload.force },
      });
    },
  },
};
